import { Swiper, SwiperSlide } from "swiper/react";
import { css } from "@emotion/react";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import "./swiper.css";
import { Autoplay } from "swiper/modules";
import { useState } from "react";

import { TemplateCard } from "@/component/retrospect/template/card/TemplateCard";

import { useNavigate } from "react-router-dom";
import { PATHS } from "@layer/shared";
import { getDeviceType } from "@/utils/deviceUtils";
import { useFunnelModal } from "@/hooks/useFunnelModal";
import RecommendDone from "@/app/desktop/component/retrospect/template/recommend/Done";
import { Z_INDEX } from "@/style/zIndex";

type CardCarouselProp = {
  spaceId?: number;
  templateId?: number;
  templateArr: {
    title: string;
    templateName: string;
    imageUrl: string;
  }[];
};

export function CardCarousel({ templateId, spaceId, templateArr }: CardCarouselProp) {
  const [isAnimating, setIsAnimating] = useState(false);
  const targetSlideIndex = 4; // 멈추고 싶은 n번째 슬라이드 인덱스 (0부터 시작)
  const navigate = useNavigate();
  const { isDesktop, isMobile } = getDeviceType();
  const { openFunnelModal } = useFunnelModal();

  const getSlideClassName = (index: number): string => {
    if (isAnimating && index === targetSlideIndex - 1) return "slide-content left";
    if (isAnimating && index === targetSlideIndex) return "slide-content animate";

    return "";
  };

  return (
    <Swiper
      slidesPerView={"auto"}
      centeredSlides={true}
      spaceBetween={16}
      initialSlide={1}
      autoplay={{
        delay: 500,
        disableOnInteraction: false,
      }}
      allowTouchMove={false}
      modules={[Autoplay]}
      onSlideChange={(swiper) => {
        if (swiper.activeIndex === targetSlideIndex) {
          swiper.autoplay.stop();
          setIsAnimating(true);
          isMobile &&
            setTimeout(() => {
              navigate(PATHS.retrospectRecommendDone(), { state: { templateId, spaceId } });
            }, 2200);

          isDesktop &&
            setTimeout(() => {
              openFunnelModal({
                title: "",
                step: "recommendTemplate",
                contents: <RecommendDone />,
              });
            }, 2200);
        }
      }}
      onInit={(swiper) => {
        swiper.autoplay.start();
      }}
      className="card-carousel"
      css={css`
        & .animate {
          z-index: ${Z_INDEX.activeSlide};
        }
      `}
    >
      {templateArr.map((template, index) => (
        <SwiperSlide key={index} className={getSlideClassName(index)}>
          <TemplateCard name={template.templateName} tag={template.title} imgUrl={template.imageUrl} scale={0.8} size="small" readOnly={true} />
        </SwiperSlide>
      ))}
    </Swiper>
  );
}
